import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';

import './Inquire.scss';


class Inquire extends Component {
  constructor(props) {
    super(props);

    this.state = {

    }
  }

  render() {
    return (
      <section id="below-banner" class="inquire">
        <div class="container">
          <div class="row">
            <div class="col-lg-12 col-md-12 col-12 middle text-center">
              <div class="step1">
                <h2>Step 1</h2>
                <p class="inquire">Enter in your information</p>
                {/* <a href="#">Read more about us <i class="far fa-arrow-circle-right"></i></a> */}

                <form class="text-left" id="inquire-form-step1">
                  <div class="row">
                    <div class="col-md-6">
                      <div class="input-holder">
                        <label for="your-first-name">First Name</label>
                        <input type="text" name="your-first-name" class="your-first-name" required />
                      </div>
                    </div>

                    <div class="col-md-6">
                      <div class="input-holder">
                        <label for="your-last-name">Last Name</label>
                        <input type="text" name="your-last-name" class="your-last-name" required />
                      </div>
                    </div>
                  </div>
                  <div class="input-holder">
                    <label for="your-phone">Your Phone</label>
                    <input type="tel" name="your-phone" class="your-phone" required />
                  </div>
                  <div class="input-holder">
                    <label for="your-email">Your Email</label>
                    <input type="email" name="your-email" class="your-email" required />
                  </div>

                  <div class="submit-holder">
                    <input type="submit" value="Next Step" />
                  </div>
                </form>
              </div>

              <div class="step2 hidden">
                <h2>Step 2</h2>
                <p class="inquire">Tell us a little about your project</p>
                {/* <a href="#">Read more about us <i class="far fa-arrow-circle-right"></i></a> */}

                <form action="" class="text-left" id="inquire-form-step2">
                  <div class="input-holder">
                    <label for="company-name">Company Name</label>
                    <input type="text" name="company-name" />
                  </div>
                  <div class="input-holder">
                    <label for="project-description">Project Description</label>
                    <textarea type="text" name="project-description" class="project-description"></textarea>
                  </div>
                  <div class="input-holder">
                    <label for="project-state">Project stage</label>
                    <div class="options">
                      <div class="single-option" id="idea">
                        <p>It's just an idea right now</p>
                      </div>

                      <div class="single-option" id="specs">
                        <p>I have the project specs</p>
                      </div>

                      <div class="single-option" id="designs">
                        <p>The designs are ready</p>
                      </div>

                      <div class="single-option" id="started">
                        <p>The project has been started</p>
                      </div>
                    </div>
                  </div>

                  <div class="input-holder budget-input">
                    <div class="label-and-price-holder">
                      <label>Project Budget</label>
                      <div class="budget-preview text-right">Drag the slider to select a budget</div>
                    </div>

                    <input type="range" min="1" max="100" value="20" data-rangeslider />
                  </div>

                  <div class="submit-holder">
                    <input type="submit" value="Submit" />
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>
    )
  }
}

export default connect()(Inquire);



// WEBPACK FOOTER //
// ./src/containers/Inquire/Inquire.js